<template>
  <div class="ca needResize" :class="{'fullscreen': fullscreen}">
    <Info @fullscreen="onFullScreen" title="ca.title" text="ca.info" ></Info>
    <div class="title">
      <h3>{{$t('ca.title')}}</h3>
      <h2>{{$t('ca.description', { currency: currency}) }}</h2>
    </div>
    <div class="main-content-ca" :class="{'full': fullscreen}" ref="mainContent" v-if="chartData[1]">
      <!--chartist ref="chart" :data="chartData" :options="chartOptions" type="Line" :event-handlers="eventHandlers"  v-if="chartData.series[0].length > 0"></chartist-->
      <GChart
        type="LineChart"
        :data="chartData"
        :options="chartOptions"
        :resizeDebounce="500"
        ref="chart"
      />
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  import currency from '../currency.js'

  export default {
    name: 'Ca',
    components: {
      Info
    },
    props: {
      result: Object, 
      nbOfColumns: Number,
      search: Object
    },
    watch: {
      result(new_value, old_value) {
        this.refresh()
      }, 
      nbOfColumns() {
        this.refresh(true)
      }
    },
    data() {
      return {
        fullscreen: false,
        chartOptions: {
          colors: ["#56D9FE", "#A3A0FB"], 
          width: 0, 
          height: 0
        },
        myHeight: 0,
        myWidth: 0
      }
    },
    computed: {
      currency() {
        return this.getCurrency();
      },

      totalHt() {
        if (!this.result || !this.result.aggregations || !this.result.aggregations["to-bills"]) return 0
        const totalSalesHt = this.result.aggregations["to-bills"].bills.details['filtered-results'].totalAmountPostDiscountTtc ?
          0 :
          this.result.aggregations["to-bills"].bills.total_sales_ht.value
        console.log("ht", this.result.aggregations["to-bills"].bills.details['filtered-results'].totalAmountPostDiscountTtc)
        return Math.round(totalSalesHt / 1000)
      },

      totalTtc() {
        if (!this.result || !this.result.aggregations || !this.result.aggregations["to-bills"]) return 0
        const totalSalesTtc = this.result.aggregations["to-bills"].bills.details['filtered-results'].totalAmountPostDiscountTtc ?
          this.result.aggregations["to-bills"].bills.details['filtered-results'].totalAmountPostDiscountTtc.value :
          this.result.aggregations["to-bills"].bills.total_sales.value
        return Math.round(totalSalesTtc / 1000)
      },

      totalData(){
        if (!this.result || !this.chartData[1]) return 0
        const reducer = (accumulator, currentValue) => accumulator + currentValue;
        // Correction de la référence à chartData car c'est un tableau de tableaux dans le nouveau GChart
        const values = this.chartData.slice(1).map(row => row[1])
        return Math.round(values.reduce(reducer, 0) / 1000)
      }, 
      chartData() {
        let labels = []
        let series = [[], []]
        
        if (this.result && this.result.aggregations && this.result.aggregations["to-bills"]) {
          const sales_per_month = this.result.aggregations["to-bills"].bills.details['filtered-results'].sales_per_month || this.result.aggregations["to-bills"].bills.sales_per_month
          if (sales_per_month) {
            labels = sales_per_month.buckets.map(s => {
              let date = new Date(s.key)
              return `${date.getMonth() + 1}/${date.getFullYear()}`
              })
            series[0] = sales_per_month.buckets.map(s => s.salesTtc.value)
            series[1] = sales_per_month.buckets.map(s => s.salesHt ? s.salesHt.value : 0)
          }
        }
        
        let result = [[this.$t('ca.date'), this.$t('ca.ht'), this.$t('ca.ttc')]]
        labels.forEach((el, i) => {
          result.push([el, series[1][i], series[0][i]])
        })
        
        return result
      }
    },
    methods: {
      getCurrency: function () {
        let methodCurrency = currency.currency(this.search.query.businessUnit),
        prefix = ''
        if(methodCurrency === '₽') {
          prefix = this.$t('ca.rusPrefix')
        }else if(methodCurrency === 'zł') {
          prefix = this.$t('ca.polPrefix')
        }else {
          prefix = this.$t('ca.euroPrefix')
        }
        return prefix + methodCurrency
      }, 
      onFullScreen() {
        this.fullscreen = !this.fullscreen
        this.refresh()
      },
      refresh(forceRefresh) {
        if(this.myHeight == 0 || forceRefresh === true) {
          this.myHeight = document.getElementsByClassName('main-content-ca')[0].clientHeight - 4
          this.myWidth = document.getElementsByClassName('main-content-ca')[0].clientWidth
        }
        if (this.fullscreen) {
          this.chartOptions.width = "70vw"
          this.chartOptions.height = "70vh"
        } else {
          this.chartOptions.width = `${this.myWidth}px`
          this.chartOptions.height = `${this.myHeight}px`
        }
      }, 
      
    },
    created() {
      let that = this
      this.eventHandlers = [{event:'created', fn() {that.$emit("refreshedChart")}}]
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/ca.sass"
</style>
